import { render, staticRenderFns } from "./IPUseBW.vue?vue&type=template&id=5aa9a12c&"
import script from "./IPUseBW.vue?vue&type=script&lang=js&"
export * from "./IPUseBW.vue?vue&type=script&lang=js&"
import style0 from "./IPUseBW.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports